<template>
  <div id="app">
    <nav class="navbar navbar-light" style="height:85px; background-color:#FFFFFF;">
      <a class="navbar-brand mt-1" href="https://www.hopesingapore.org.sg/contributeroles">
        <img src="./assets/hope-church-logo-colour.svg" height="60px" alt />
      </a>
      <div>
        <a class="navbar-brand ml-3" style="margin-right:100px" href="#/adminhome">Admin</a>
      </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
window.isMobileView = function() {
  var check = false;
  (function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

import Vue from "vue";

// Font Awesome Free
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// vue-boostrap-datetimepicker
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import datePicker from "vue-bootstrap-datetimepicker";
Vue.use(datePicker);

// Autocomplete
import Autocomplete from "vuejs-auto-complete";
Vue.component("autocomplete", Autocomplete);

// Pagination
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

// Router
import router from "./router/index.js";

// Lodash
Vue.use(require("vue-moment"));
import VueLodash from "vue-lodash";
const options = { name: "lodash" }; // customize the way you want to call it
Vue.use(VueLodash, options); // options is optional

import Browse from "@/components/Browse";

export default {
  name: "app",
  components: {
    Browse
  },
  router: router
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.top-margin {
  margin-top: 30px;
}

.left-margin {
  margin-left: 30px;
}

.all-margin {
  margin: 30px;
}

.all-padding {
  padding: 30px;
}

.loader {
  border: 7px solid #f3f3f3; /* Light grey */
  border-top: 7px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 25px;
  height: 25px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "TradeGothic LT BoldTwo", sans-serif;
}

@font-face {
  font-family: "TradeGothic LT Light";
  src: url("./assets/fonts/TradeGothicLT-Light.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-Light.woff") format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT Oblique";
  src: url("./assets/fonts/TradeGothicLT-Oblique.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-Oblique.woff") format("woff");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT BoldTwo";
  src: url("./assets/fonts/TradeGothicLT-BoldTwo.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldTwo.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT BoldOblique";
  src: url("./assets/fonts/TradeGothicLT-BoldOblique.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldOblique.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT BoldCOndTwentyObl";
  src: url("./assets/fonts/TradeGothicLT-BoldCondTwentyObl.woff2")
      format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldCondTwentyObl.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT";
  src: url("./assets/fonts/TradeGothicLT.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT Extended";
  src: url("./assets/fonts/TradeGothicLT-Extended.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-Extended.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT Bold";
  src: url("./assets/fonts/TradeGothicLT-Bold.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT Light Oblique";
  src: url("./assets/fonts/TradeGothicLT-LightOblique.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-LightOblique.woff") format("woff");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT CondEighteen";
  src: url("./assets/fonts/TradeGothicLT-CondEighteenObl.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-CondEighteenObl.woff") format("woff");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT BoldExtended";
  src: url("./assets/fonts/TradeGothicLT-BoldExtended.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldExtended.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic LT BoldCondTwenty";
  src: url("./assets/fonts/TradeGothicLT-BoldCondTwenty.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldCondTwenty.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "TradeGothic BOldTwoOblique";
  src: url("./assets/fonts/TradeGothicLT-BoldTwoOblique.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-BoldTwoOblique.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "TradeGothic LT CondEighteen";
  src: url("./assets/fonts/TradeGothicLT-CondEighteen.woff2") format("woff2"),
    url("./assets/fonts/TradeGothicLT-CondEighteen.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
</style>
